import type { TemplateProfile } from '../../types'

export const selectPreferredTemplateProfile = (
  profiles: TemplateProfile[],
  fallback: TemplateProfile,
): TemplateProfile =>
  profiles.find((profile) => profile.key === 'kit_delivery') ?? profiles[0] ?? fallback
